export const defaultErrorTitle = "Error!"
export const defaultErrorMessage = "An error occurred. Please try again later."
export const defaultApiErrorMessage =
  "An error occurred while processing your request. Please try again later."
